<script>
import {setSystemSettingInfo, getSettingItem} from "@/api/setting-api";

export default {
  name: "GuardSettingPage",
  data() {
    return {
      guardLIst: [],
      form: {
        guards: [],
        guardSignConfig: 3, // 1=不展示, 2=选填, 3=必填; 默认必填
      }
    };
  },
  mounted() {
    this.loadGuardSignConfig()
    this.resetForm()
  },
  methods: {
    loadGuardSignConfig() {
      getSettingItem("MANAGE", "GUARD_SIGN_SETTING").then(({data}) => {
        if (data.code === 200 && data.data && data.data.length > 0) {
          let setting = data.data[0]
          if (setting.content) {
            this.form.guardSignConfig = parseInt(setting.content)
          }
        }
      }).catch(err => {
        console.log("loadGuardSignConfig err", err)
      })
    },
    addGuaid() {
      this.form.guards.push({value: ''})
    },
    resetForm() {
      this.form.guards = []
      this.guardLIst = this.$store.state.guardSignList
      this.guardLIst.forEach((item, index) => {
        this.form.guards.push({values: item})
      })
    },
    submitForm() {
      let guardSignList = []
      this.form.guards.forEach((item, index) => {
        if (item.values) {
          guardSignList.push(item.values)
        }
      })
      this.$store.commit('setGuardSignList', guardSignList)

      // 保存保安签名配置到后端
      let postData = {
        target: "MANAGE",
        type: "GUARD_SIGN_SETTING",
        content: String(this.form.guardSignConfig),
        state: "VALID"
      }
      setSystemSettingInfo(postData).then(({data}) => {
        if (data.code === 200) {
          this.$message.success("保存成功")
        } else {
          this.$message.error("保存失败")
        }
      }).catch(err => {
        console.log("saveGuardSignConfig err", err)
        this.$message.error("保存失败")
      })

      this.resetForm()
    },
    removeGuaid(guaid, index) {
      this.form.guards.splice(index, 1)
    }
  },
}
</script>

<template>
  <div>
    <el-form :model="form" ref="form" label-width="120px" class="demo-dynamic">

      <h3 class="section-title">保安签名字段配置</h3>
      <el-form-item label="保安签名：">
        <el-radio-group v-model="form.guardSignConfig">
          <el-radio :label="3">必填</el-radio>
          <el-radio :label="2">选填</el-radio>
          <el-radio :label="1">不展示</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-divider></el-divider>

      <h3 class="section-title">保安人员列表</h3>
      <div class="flex flex-wrap justify-start">
        <el-form-item
            class="w-1/3"
            v-for="(guard, index) in form.guards"
            :label="`保安${index + 1}`"
            :key="index">

          <el-input v-model="guard.values">
            <el-button slot="append" icon="el-icon-delete" @click="removeGuaid(guard, index)"></el-button>
          </el-input>

        </el-form-item>
      </div>
      <div class="flex justify-center">
        <el-form-item>
          <el-button type="primary" @click="submitForm()">保存</el-button>
          <el-button @click="addGuaid">新增保安</el-button>
          <el-button @click="resetForm('dynamicValidateForm')">重置</el-button>
        </el-form-item>

      </div>

    </el-form>


  </div>
</template>

<style scoped lang="less">
.demo-dynamic{
  padding: 20px 40px;

  /deep/ .el-form-item__label {
    font-size: 14px;
  }

  .el-radio {
    height: 44px;
    line-height: 44px;
  }

  /deep/ .el-radio__label {
    font-size: 14px;
  }

  .el-select {
    width: 100%;
  }

  /deep/ .el-input__inner {
    font-size: 14px;
  }
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  margin: 16px 0 12px;
}
</style>
